export const emptyComparisonExpressionConfig = () => ({
  expr: void 0,
  left: {
    expr: "number-ref",
    ref: void 0
  },
  right: {
    expr: "number",
    value: 0
  }
});
export const emptyBooleanExpressionConfig = ({
  operator = "&&",
  left = emptyComparisonExpressionConfig(),
  right = emptyComparisonExpressionConfig()
}) => ({
  expr: operator,
  left,
  right
});
export const emptyGroupExpressionConfig = ({
  operator = "&&",
  child = emptyComparisonExpressionConfig()
}) => ({
  expr: "group",
  operator,
  child
});
export const replaceBooleanExpressionOperatorInGroup = (nextOperator, expression) => {
  if (expression.expr === "&&" || expression.expr === "||") {
    const boolExpr = expression;
    return {
      expr: nextOperator,
      left: replaceBooleanExpressionOperatorInGroup(nextOperator, boolExpr.left),
      right: replaceBooleanExpressionOperatorInGroup(nextOperator, boolExpr.right)
    };
  }
  return expression;
};
